import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SG_APP_APRV_HIST_LIST,
    SF_APP_DTL_EXMPN_TAX,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";

export const APP_DTL_DCLR = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0142" }],
    });

    const [aprvHistList, setAprvHistList] = useState(comnUtils.getGridData([]));
    const [exmpnTaxVisible, setexmpnTaxVisible] = useState(false);

    const form = {
        appDtlExmpnTax: useForm({
            defaultSchema: SF_APP_DTL_EXMPN_TAX,
        }),
    };

    /*
     * Application Approval History List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Application Approval History List !== 신청서 승인 이력 목록 ==!
        appDtlAprvHistList: useGrid({
            defaultSchema: SG_APP_APRV_HIST_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Application Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAppAprvhistList: useFetch({
            api: (page = grid.appDtlAprvHistList.page) => {
                return COMN_APIS.getAppAprvhistList({ ...props.state }, page, grid.appDtlAprvHistList.size);
            },
            key: [grid.appDtlAprvHistList.page, grid.appDtlAprvHistList.size],
            onSuccess: (data) => {
                if (data.appAprvHistList.content!) {
                    let prcssStatCd = "";
                    if (data.appAprvHistList.content.length > 0) {
                        for (let i = 0; i < data.appAprvHistList.content.length; i++) {
                            prcssStatCd = data.appAprvHistList.content[i].prcssStatCd;
                            if ("SU" == prcssStatCd) {
                                // data.appAprvHistList.content[i].prcssRsnNm = "Purppose";
                            } else {
                                if (data.appAprvHistList.content[i].prcssRsnCn) {
                                    data.appAprvHistList.content[i].prcssRsnNm = "Conditions of Approval";
                                }
                            }
                            data.appAprvHistList.content[i].aprvRmrk = "Remarks";
                            setAprvHistList(comnUtils.getGridData(data.appAprvHistList.content || []));
                        }
                    }
                }
            },
            onError: () => {},
            showToast: false,
        }),
        getAppExmpnTaxList: useFetch({
            api: () => {
                return COMN_APIS.getAppExmpnTaxList({ ...props.state });
            },
            onSuccess: (data) => {
                if (data.exmpnTaxList.content!) {
                    setexmpnTaxVisible(true);
                    form.appDtlExmpnTax.setValue("exmpnTaxTpCd", data.exmpnTaxList.content);
                }
            },
            onError: () => {},
            showToast: false,
        }),
    };

    /*
     * Application Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Application Item List !== 신청서 품목 목록 조회 ==!
        getAppAprvhistList: (page: number = 0) => {
            grid.appDtlAprvHistList.setPage(page);
            fetch.getAppAprvhistList.fetch(page);
        },
    };

    useEffect(() => {
        handler.getAppAprvhistList();
        if ("EA" == props.state.appTpCd) {
            fetch.getAppExmpnTaxList.fetch();
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_APRV_HIST"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group>
                            <Group.Body>
                                <Grid {...grid.appDtlAprvHistList.grid} data={aprvHistList} />
                            </Group.Body>
                        </Group>
                    </Layout>
                </Group.Body>
            </Group>

            {exmpnTaxVisible && (
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"Taxes Exemptions"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlExmpnTax.schema.exmpnTaxTpCd} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                    </Group.Body>
                </Group>
            )}
        </Page>
    );
};
